import { DataBean } from "../DataBean";

export class QuotaUpdateForItems extends DataBean {



    public async importDepreciationQuotaUpdateForItems(filename: any, directory: any, dataStore: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_importDepreciationQuotaUpdateForItems_String_String_String", [filename, directory, dataStore]);
    }

}
